
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form20";
const form20State = namespace("Form20");

import Form20ProcessHeader from "@/components/process/Form20/components/Form20ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { form20StatusInfoType } from '@/types/Information/Form20';
import { packageInfoType } from '@/types/Information';

@Component({
    components:{
        Form20ProcessHeader,
        Spinner
    }
})
export default class SubmitForm20 extends Vue {

    @form20State.State
    public currentNoticeOfObjectionToWithdrawalId: string;

    stepsCompleted = {} as form20StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/form20/efiling/"+this.currentNoticeOfObjectionToWithdrawalId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.post(url, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
